import { SUBSCRIPTIONS_CUSTOMER_SCOOP_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_UPDATE_SCOOP_PATH_SUFFIX = "/update";
/** /customer/subscription/scoop/update */
export const SUBSCRIPTIONS_CUSTOMER_UPDATE_SCOOP_PATH = `${SUBSCRIPTIONS_CUSTOMER_SCOOP_CONTROLLER_ROOT_PATH}${SUBSCRIPTIONS_CUSTOMER_UPDATE_SCOOP_PATH_SUFFIX}`;
